import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { EventManagerService } from 'src/app/core/services/event-manager/event-manager.service';
import { ConfirmationModalComponent } from 'src/app/shared/confirmation-modal/confirmation-modal.component';
import { TeacherActivity } from '../../../../../core/services/http/dashboard/interfaces/teacher-activity';
import { User } from '../../../../../core/services/http/user/interfaces/user';

@Component({
  selector: 'app-employee-activity-info-modal',
  templateUrl: './employee-activity-info-modal.component.html',
  styleUrls: ['./employee-activity-info-modal.component.scss']
})
export class EmployeeActivityInfoModalComponent extends ConfirmationModalComponent {
  teacherActivity: TeacherActivity | undefined;
  teacher: User | undefined;

  constructor(protected modalRef: BsModalRef, protected eventManager: EventManagerService) {
    super(modalRef, eventManager);
  }
}
